import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { AuthProvider } from './contexts/AuthContext';
import { PasswordResetModal } from './components/PasswordResetModal';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <PasswordResetModal />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
